module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.insertShape)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08e9bba4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icon.vue
// module id = 192
// module chunks = 0